module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/htitle.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "titlepage"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "image/ftitle.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "ded"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    staticClass: "_idGenPageitem-1",
    attrs: {
      "alt": "",
      "src": "image/Guinea1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "basic"
  }), _vm._v(" "), _c('p', {
    staticClass: "chquote"
  }, [_vm._v("I dedicate this book to preserving and protecting the humbling beauty and bountiful natural resources of the Blue Ridge Mountains, and to celebrating the indefatigable spirit that endures in the mountain South. Here’s to all of the generations before and after who lift their eyes up to the hills with gratitude, reverence, and awe.  ")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    staticClass: "_idGenPageitem-3",
    attrs: {
      "alt": "Picture of Jars",
      "src": "image/IMG_2623.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "newchapnew"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "basic"
  }), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('a', {
    attrs: {
      "href": "#/#Acknowledgments"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('a', {
    attrs: {
      "href": "#/#foreword"
    }
  }, [_vm._v("Foreword")]), _vm._v(" by Chef Sean Brock")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('a', {
    attrs: {
      "href": "#/#Introduction"
    }
  }, [_vm._v("Introduction:")]), _vm._v(" Why We Serve You Biscuits and Blueberry Preserves First Thing")]), _vm._v(" "), _c('p', {
    staticClass: "basic"
  }), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('a', {
    attrs: {
      "href": "#/52249txt1#MOOnshine-thunder-rOad--and-mOuntain-elixirs"
    }
  }, [_vm._v("Moonshine “Thunder Road,” and Mountain Elixirs")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('a', {
    attrs: {
      "href": "#/52249txt2#Road-Tripping-and-Picnicking"
    }
  }, [_vm._v("Road Tripping and Picnicking")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('a', {
    attrs: {
      "href": "#/52249txt3#NeighbOrlY-HOllers--Valleys-and-RidgetOps"
    }
  }, [_vm._v("Neighborly Hollers, Valleys and Ridgetops")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('a', {
    attrs: {
      "href": "#/52249txt4#Native-American-TraditiOns-anD-the-Three-Sisters"
    }
  }, [_vm._v("Native American Traditions and the Three Sisters")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('a', {
    attrs: {
      "href": "#/52249txt5#Get-yOur-daily-grind"
    }
  }, [_vm._v("Get Your Daily Grind")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('a', {
    attrs: {
      "href": "#/52249txt6#POrcine-LOve"
    }
  }, [_vm._v("Porcine Love")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('a', {
    attrs: {
      "href": "#/52249txt7#mOuntains-tO-the-sea"
    }
  }, [_vm._v("Mountains to the Sea")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('a', {
    attrs: {
      "href": "#/52249txt8#Yard-birds-and-game-birds"
    }
  }, [_vm._v("Yard Birds and Game Birds")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('a', {
    attrs: {
      "href": "#/52249txt9#The-Sweetness-Of-MOuntain-sOil"
    }
  }, [_vm._v("The Sweetness of Mountain Soil")])]), _vm._v(" "), _c('p', {
    staticClass: "basic"
  }), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('a', {
    attrs: {
      "href": "#/52249txt10#Metric-Con"
    }
  }, [_vm._v("Metric Conversions and Equivalents")])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "newchapnew"
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('a', {
    attrs: {
      "id": "Acknowledgments"
    }
  }), _vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "basic"
  }), _vm._v(" "), _c('p', {
    staticClass: "chtext"
  }, [_vm._v("I would like to thank Steve and Jennifer Frabitore for their thoughtful stewardship of Tupelo Honey Cafe’s values and for their hugely supportive belief in me. And gratefulness to Chef Brian Sonoskus, who is not only an incredibly talented chef, but also a great friend and a creative collaborator. Thank you for being such a terrifically fun partner on this book. ")]), _vm._v(" "), _c('p', {
    staticClass: "chtext"
  }, [_vm._v("Brie Williams is a photographic genius and a woman of sweetness and light. My colleague Lynne Caldwell has kept me sane with her resourcefulness, her kind heart, and her generous spirit. And Debby Maugans’s expertise in the kitchen and behind the scenes has been enormously valuable. ")]), _vm._v(" "), _c('p', {
    staticClass: "chtext"
  }, [_vm._v("I am grateful to my siblings—Roger, Mary Jane, and Lusby—who have helped nurture in me a profound appreciation for our father’s roots in the mountains of eastern Kentucky and southwest Virginia. Myrtle, Harlan, Lula, Scott, Lillian, John, Nell, and, of course, Daddy, I am hoping you would enjoy this book. ")]), _vm._v(" "), _c('p', {
    staticClass: "chtext"
  }, [_vm._v("Thank you, Miriam Lusby Brown, for instilling in me a love of gathering family and friends around the table. You are always a powerful presence in my kitchen and in my life. ")]), _vm._v(" "), _c('p', {
    staticClass: "chtext"
  }, [_vm._v("Thank you, too, to the strong women who are my rock—Marla, Peggy, Jaeger, Deb, Sheila, Rachel, and Barb. I couldn’t have done this without you. ")]), _vm._v(" "), _c('p', {
    staticClass: "chtext"
  }, [_vm._v("I am deeply indebted to the visionaries who created the journey that is the Blue Ridge Parkway and the inspiration I received traveling this majestic scenic byway and experiencing the people, culture, music, stories, history, and spirit of the Blue Ridge Mountains. ")]), _vm._v(" "), _c('p', {
    staticClass: "chtext"
  }, [_vm._v("Thank you, Vicki Dameron, for your generous contribution of breathtaking imagery of the region and your consistent support for the preservation of the Blue Ridge Parkway and the natural beauty along its route. And I am most grateful to Julie Barnes for her talented art direction, to our editor Jean Lucas for pushing us to make the book as good as it could possibly be, and to our publisher Kirsty Melville and Andrews McMeel for believing in the project. ")]), _vm._v(" "), _c('p', {
    staticClass: "chtext"
  }, [_vm._v("Thank you, Chef Sean Brock, a native mountain son, for your thoughtful foreword, and for your support and encouragement. I am forever indebted to my Southern Foodways Alliance family, who continue to fuel my journey of understanding and appreciation of our region and its richness and complexity of place, foodways, history, traditions, and character, especially my fellow mountaineers (Sheri Castle, John Fleer, Fred Sauceman, and Allan Benton—you know who you are!). John Egerton, you had a really good idea—thank you, my friend.")]), _vm._v(" "), _c('p', {
    staticClass: "chtext"
  }, [_vm._v("Thank you, Ronni Lundy. You have taught me much about the richness of Appalachia with your God-given gift with words, your incredibly wise insights, your love of mountain music and the powerful and ancient energy it carries, your contagious laughter, and your loving hillbilly spirit. And finally, here’s to Zoe, my little mountain girl.")]), _vm._v(" "), _c('p', {
    staticClass: "chquoteatt"
  }, [_vm._v("– Elizabeth Sims")]), _vm._v(" "), _c('p', {
    staticClass: "basic"
  }), _vm._v(" "), _c('p', {
    staticClass: "chtext"
  }, [_vm._v("Cheers to new South flavors! ")]), _vm._v(" "), _c('p', {
    staticClass: "chtext"
  }, [_vm._v("I would like to thank the people of Asheville, Knoxville, Greenville, Chattanooga, Charlotte, and Johnson City for your continued support and encouragement. ")]), _vm._v(" "), _c('p', {
    staticClass: "chtext"
  }, [_vm._v("Many blessings to my family—none of this would be possible without you.")]), _vm._v(" "), _c('p', {
    staticClass: "chtext"
  }, [_vm._v("And thank you to the entire THC team for keeping this party on the road! ")]), _vm._v(" "), _c('p', {
    staticClass: "chtext"
  }, [_vm._v("Kate, Jack and Jane—I love you! xoxoxo")]), _vm._v(" "), _c('p', {
    staticClass: "chquoteattB"
  }, [_vm._v("– Brian Sonoskus")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    staticClass: "_idGenPageitem-1",
    attrs: {
      "alt": "barns in the field",
      "src": "image/IMG_2156_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "newchapnew"
  }, [_c('a', {
    attrs: {
      "id": "foreword"
    }
  }), _c('span', {
    staticClass: "blue"
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "chtext"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("by Chef Sean Brock")])]), _vm._v(" "), _c('p', {
    staticClass: "chtext"
  }, [_vm._v("I grew up deep in the mountains of southwestern Virginia in a tiny little town of 1,000 people called Pound located in in Wise County. In that particular part of the country, things are done a certain way; a very unique way of living exists there. We value things like a deep connection to the land, family, and the idea that we can take care of ourselves no matter what. I had no idea how lucky I was to have grown up that way until I was older. Working the fields, always having my hands in food, and sitting on the porch listening to my grandmother tell stories of the way things used to be were all part of my childhood. I honestly had no idea at the time it would be those values and practices that would help shape me into the chef that I am today. ")]), _vm._v(" "), _c('p', {
    staticClass: "chtext"
  }, [_vm._v("The people of the mountain South haven’t changed a whole lot since then. It’s just the way people enjoy living. I suppose it’s the geography and possibly the fact we are tucked away by ourselves, the mountains shielding us from the rest of society. My mother is a perfect example. She lived in the mountains all of her life but moved to Charleston a few years ago to be closer to me. She still talks exactly the same with that incredible Appalachian dialect, saying things like “fixin to” and “ove are,” which translates to “over there,” by the way. She still eats cornbread just about everyday and cans like the apocalypse is upon us every year. If you’ve ever received a behind-the-scenes tour of my restaurants you’ll find the same things packed away in crocks and mason jars that you would have found in my grandmother’s basement. Those kinds of needs and wants are built into you; they flow through your veins. Once they are there they aren’t going anywhere. And I reckon that’s the way it should be. Because it’s important to live like a hillbilly no matter where you end up when it’s in your blood. I know I always will and will raise my children the same way that my family raised me. ")]), _vm._v(" "), _c('p', {
    staticClass: "chtext"
  }, [_vm._v("It’s fascinating to explore the hollers and back roads of the mountain South, listening to the stories and eating the food from the last of the old timers. You’ll hear stories of how much better the tomatoes used to taste and what it was like to ring a chicken’s neck when you were hungry. These days I’m scared to death that these traditions and stories will die. That frightens me because I’m proud of the way I grew up and I’m proud of the way my family raised me and the respect that it instilled in me for food and family.")]), _vm._v(" "), _c('p', {
    staticClass: "chtext"
  }, [_vm._v("All of my chores as a kid were focused on food in some way. I didn’t realize it at the time, but it was those darn chores that made me fall in love with food and realize the power of the table. We ate together every day and every night. That’s just the way it was. We didn’t have a single restaurant to go to, in fact. There was always something simmering away on the stove or some sort of activity going on in the kitchen. I remember the first time my grandmother asked me to string up greasy beans using a needle and thread. I thought she had lost her mind or we were going to use them instead of popcorn to decorate the Christmas tree. I’ll never forget watching them slowly dry above her wood burning stove and the flavor they packed when cooked on the stove with just a little oil. "), _c('a', {
    attrs: {
      "id": "x.95219"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chtext"
  }, [_vm._v("A lot of people hear of Southern food or Southern culture and think that its just one thing. I have news for you; the South is one of the most culturally diverse regions in the world. And the food of the mountain South can only be found there. A lot of people have the wrong idea about Southern food. They tend to think that the cuisine is deep fried and unhealthy. We rarely ate meat and hardly ever ate anything fried. The cuisine of the mountain South is very vegetable driven. If you were eating meat, it was the result of a hunting or fishing trip. Geography plays a major role in shaping a culture. Growing up and eating in southwestern Virginia is the exact opposite of growing up and eating in the South Carolina low country. I left the mountains to attend culinary school in Charleston, South Carolina, when I was eighteen. The cuisine that I discovered there might as well have been Japanese and the mountain cuisine that I spoke of at school might as well have been food from Mars. “You’ve never had a paw paw?” “What do you mean you don’t know what killed lettuce is?” The more and more I spoke about the cuisine of the mountain South to the cooks of the low country kitchens, the more I realized how rare and special it was. Every time I went home to visit I always brought back something for show and tell. The first time I brought a garbage bag full of paw paws back to the kitchen was hilarious. Paw paws have a very tropical flavor, one that you wouldn’t expect to receive from a kid with a deep hillbilly accent. People still talk about that day fifteen years later. ")]), _vm._v(" "), _c('p', {
    staticClass: "chtext"
  }, [_vm._v("As my grandmother was getting older,  I knew that I needed to learn as much as possible from her while I could. Those years were the fondest for me, cooking beside my grandmother as a young adult and most importantly an eager student. She knew that I cared and would pass the food down to the next generations. Several years ago I decided that I wanted to start doing extensive research on the food that I grew up eating. I knew how important it was and how crucial it was to gather as much information as possible. I sent out some e-mails and posted some things on social media. And to my disappointment there weren’t very many resources out there for this particular cuisine. The cuisine of the mountain South hasn’t exactly been celebrated by chefs in fancy chef coats or featured on television programs. It stays in the mountains and in the kitchens of the people who live it and breath it. It’s a way of life and not a trend. The current trend of foraging always makes me chuckle a little because we were always hunting wild foods such as morel mushrooms, elderberries, wild ramps, and pokeweed. My goal is to make mountain food trendy some day so people can understand hillbilly culture through our food. It’s a beautiful way to live and I have a lifetime of research ahead of me. ")]), _vm._v(" "), _c('p', {
    staticClass: "chtext"
  }, [_vm._v("In this book you’ll find a glimpse of where mountain cuisine is today. This generation is still proud of old traditions such as cornbread and canning. In "), _c('span', {
    staticClass: "chtextitalic"
  }, [_c('em', [_vm._v("Tupelo Honey Cafe: New Southern Flavors from the Blue Ridge Mountains")])]), _vm._v(", the traditions of mountain cuisine are looked at through a modern lens. This is how you keep a tradition and culture alive, but also how you help to move it forward. I’ll cheers to that.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "chquote"
  }, [_c('a', {
    attrs: {
      "id": "nation1"
    }
  }), _vm._v("For the last century and then some, the culture of America at large has been a culture of things. From its onset, the culture of the Southern mountains has been one of connection. Being intangible, the treasures of the latter are virtually invisible. . . . A life focused on fostering connection, as opposed to acquisition, might seem to the dominant culture, at best, quaint and anachronistic, at worst, ridiculous and perverse. ")]), _vm._v(" "), _c('p', {
    staticClass: "chquoteatt"
  }, [_vm._v("—Ronni Lundy, Cornbread Nation 3")]), _vm._v(" "), _c('p', {
    staticClass: "basic"
  }), _vm._v(" "), _c('p', {
    staticClass: "newchapnew"
  }, [_c('a', {
    attrs: {
      "id": "Introduction"
    }
  }), _c('span', {
    staticClass: "blue"
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "chtextcenter"
  }, [_vm._v("Why We Serve You Biscuits and Blueberry Preserves First Thing")]), _vm._v(" "), _c('p', {
    staticClass: "chtext"
  }, [_vm._v("The mountain South is a region of beautiful and complex paradox. It is at once rugged and awe inspiring, breathtakingly scenic, and lush, with one of the most biologically diverse landscapes of flora and fauna in the world. Elevated vantage points offer sweeping views of the rich blue and green valleys and coves and world below. The towns and communities that fill the coves and hollers honor and embrace their collective heritage, history, tradition, and culture—sometimes, say its critics, to the detriment of being able to gaze ahead.")]), _vm._v(" "), _c('p', {
    staticClass: "chtext"
  }, [_vm._v("The region has inspired writers and artists and poets and social reformers. Here, self-sufficiency and industriousness are ingrained in the culture, moral fiber, and fabric of mountain life. ")]), _vm._v(" "), _c('p', {
    staticClass: "chtext"
  }, [_vm._v("And here is where the paradox continues. The fiercely self-sufficient and independent spirit of the mountain South is inextricably linked to the innate need for connection–with family and friends, through story and song, by way of history and culture and tradition, and through the very simple act of sharing a meal. ")]), _vm._v(" "), _c('p', {
    staticClass: "chtext"
  }, [_vm._v("At Tupelo Honey Cafe, we believe in the transcendent power of gathering around the table. We see it all the time in the restaurant. It’s why we bring you hot biscuits and blueberry preserves first thing. Everyone dives in, passing dishes around the table, sharing with one another. Barriers are lifted. Transgressions are at least momentarily forgotten.")]), _vm._v(" "), _c('p', {
    staticClass: "chtext"
  }, [_vm._v("In the communities where we live and work, we encourage friends and families to take the time to gather around the table together at home. It’s a simple act, but a forceful, transformative one that can strengthen the common bonds that tie us together. ")]), _vm._v(" "), _c('p', {
    staticClass: "chtext"
  }, [_vm._v("This fundamental need for connection is not unique to the Blue Ridge, of course, but it is integral to Appalachian values. Community and connectivity are vividly played out—often with food as the central character—along mountain landscapes on a daily basis. It is the stuff of quilting bees and barn raisings, church suppers on the grounds, and the neighborhood potluck supper. It is a collective front porch stringing of greasy beans and shucking of corn, the communal kitchen filled with the scented steam of apples on their way to apple butter. It is the male community’s coming together around the ritual of hog killing on the first frosty morning of late autumn or the family’s attention to planting their own truck patch in the spring or the community working diligently in ramp houses or as a team going molly mooching. It is the way mountain stories and folklore, mountain fiddles and clogging, and mountain song and shape note singing are gathered, shared, and passed down to another generation. ")]), _vm._v(" "), _c('p', {
    staticClass: "chtext"
  }, [_vm._v("The terrain of the mountain South might characteristically lend itself to isolation, since getting from one place to the next can be at the mercy of the creeks overflowing or the snow falling or the road being washed away. It makes sense, then, that hearty mountaineers take great pleasure (stubbornness is a mountain virtue) in rising to the challenge of maintaining vital connections with one another. In the 1930s, when the Great Depression brought even greater economic obstacles to mountain living, the concept for an actual physical connector/corridor, placed along the geographic spine of the Blue Ridge Mountains, was introduced: a road that would help facilitate the back-and-forth of mountaineers between coves and communities. The 469-mile Blue Ridge Parkway—a spectacularly beautiful scenic byway and virtual celebration of mountain heritage and culture—continues to be a way for farms, families, and communities along the road to stay connected. ")]), _vm._v(" "), _c('p', {
    staticClass: "chtext"
  }, [_vm._v("It is our hope this collection of recipes from Tupelo Honey Cafe will serve as a catalyst for connection in your own home. Our recipes are flavorful and creative, but they are not intimidating, and we encourage you to pull this book out regularly, gather friends and family around your kitchen table, and celebrate community and communion. Collect your crew and cook a meal together. Organize a neighborhood potluck. Pack up the picnic basket and enjoy time together outdoors. Cook something for a new neighbor, a friend who’s under the weather, a young family with a new baby. It’s that simple. ")]), _vm._v(" "), _c('p', {
    staticClass: "chtext"
  }, [_vm._v("Just pass around the biscuits. ")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "xiii"
    }
  }), _c('img', {
    staticClass: "_idGenPageitem-3",
    attrs: {
      "alt": "house in field",
      "src": "image/northsign.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    staticClass: "_idGenPageitem-3",
    attrs: {
      "alt": "house in field",
      "src": "image/IMG_2939.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32fef08c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/52249txt.vue
// module id = 60
// module chunks = 0